"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockDeferLiquidityCheckCallerFailLiquidityFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "tectonicCoreAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tTokenAddress",
                type: "address",
            },
        ],
        name: "callTectonicCore",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "onDeferredLiquidityCheck",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "tTokenAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class MockDeferLiquidityCheckCallerFailLiquidityFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MockDeferLiquidityCheckCallerFailLiquidityFactory = MockDeferLiquidityCheckCallerFailLiquidityFactory;
MockDeferLiquidityCheckCallerFailLiquidityFactory.bytecode = _bytecode;
MockDeferLiquidityCheckCallerFailLiquidityFactory.abi = _abi;
//# sourceMappingURL=MockDeferLiquidityCheckCallerFailLiquidityFactory.js.map